<template>
    <div class="cms-container mb-4">
        <ToastCMS ref="toast" />
        <!-- PREVIEW IMAGE -->
        <div v-if="showPreviewModal" class="preview-modal w-100 h-100 d-flex align-items-center justify-content-center"
            @click.self="closePreviewImage">
            <div class="d-block-align-items-center justify-content-center w-100 mx-3">
                <div class="modal-content bg-transparent position-relative border-0">
                    <button class="close-btn position-fixed text-white bg-transparent border-0"
                        @click="closePreviewImage">&times;</button>

                    <div class="d-flex justify-content-between align-items-center border-0">
                        <button v-if="previewImages.length > 1" @click="prevImage" :disabled="currentPreviewIndex === 0"
                            class="material-symbols-outlined bg-transparent border-0 text-white">
                            arrow_back_ios
                        </button>

                        <video v-if="previewIsVideo" :src="previewImages[currentPreviewIndex]" controls muted
                            style="max-width:70vw; max-height:70vh; display:block; margin:0 auto;"></video>
                        <img v-else :src="previewImages[currentPreviewIndex]" alt="Preview Image">

                        <button v-if="previewImages.length > 1" @click="nextImage"
                            :disabled="currentPreviewIndex === previewImages.length - 1"
                            class="material-symbols-outlined bg-transparent border-0 text-white">
                            arrow_forward_ios
                        </button>
                    </div>
                </div>

                <div v-if="previewImages.length > 1" class="text-center mt-3">
                    <span class="text-white">Image {{ currentPreviewIndex + 1 }} of {{ previewImages.length }}</span>
                </div>
            </div>
        </div>
        <div class="sticky-controls">
            <div class="main-header d-flex align-items-center justify-content-between mb-3 px-3">
                <div class="crew-header text-dark">Crew Development</div>
                <button type="button" class="vmc-bg-prime-4 border-0 text-white rounded px-2 py-1"
                    @click="addContainer">
                    Add Item
                </button>
            </div>
        </div>
        <!-- BACKGROUND MEDIA — separate from item list -->
        <div class="px-3">
            <div class="mt-4">
                <div class="d-flex align-items-center justify-content-between w-100 my-2">
                    <div class="d-flex align-items-center justify-content-between w-100 mt-2">
                        <span class="item-number text-dark">
                            Background Media (MP4 or Image, Max 10MB)
                        </span>
                        <div class="d-flex align-items-center" style="gap:5px;">
                            <button type="button" @click="previewBgMedia"
                                class="vmc-bg-prime-4 text-white rounded px-3 py-1 border-0">
                                View
                            </button>
                        </div>
                    </div>
                </div>
                <div
                    style="height:200px; width:100%; background-position:center; border:1px solid gray; margin-bottom:10px; display:flex; justify-content:center; align-items:center; overflow:hidden;">

                    <video v-if="trainingBackgroundVideo" :src="trainingBackgroundVideo" class="w-100 h-100" controls
                        muted style="object-fit:contain;"></video>
                    <img v-else-if="trainingBackgroundImage" :src="trainingBackgroundImage" class="w-100 h-100"
                        style="object-fit:contain;">

                    <template v-else>
                        <input type="file" id="upload-training-bg" accept="video/mp4, image/png, image/jpeg, image/jpg"
                            hidden @change="onBgMediaChange($event)">
                        <label for="upload-training-bg"
                            class="w-100 h-100 d-flex flex-column justify-content-center align-items-center text-center"
                            style="cursor:pointer;">
                            <i class="material-symbols-outlined">upload</i>
                            <span>Upload Background (MP4 or Image)</span>
                        </label>
                    </template>
                </div>
                <button @click="removeBgMedia" type="button"
                    class="w-100 vmc-bg-prime-6 py-1 text-white mt-1 border-0 rounded">
                    Remove Media
                </button>
            </div>
        </div>
        <!-- PAGE INTRO TEXT -->
        <div class="px-3 mt-4 mb-3">
            <label class="text-dark item-number">Page Intro Text:</label>
            <textarea rows="3" class="w-100 text-dark p-1 mt-1" placeholder="Page intro text..." v-model="trainingIntro"
                style="border:1px solid gray; border-radius:4px; font-size:15px; resize:none; outline:none;"></textarea>
        </div>
        <form action="" id="crewdevelopment" @submit.prevent="saveAllChanges">
            <div class="pb-3">
                <div class="grid-header">
                    <div class="w-100 mt-4" v-for="(container, index) in containers" :key="index">
                        <div class="mb-4 px-2">
                            <div class="d-flex align-items-center justify-content-between mb-2 px-2">
                                <span class="item-number text-dark">
                                    Item # {{ index + 1 }}
                                </span>
                                <button type="button" class="vmc-bg-prime-6 text-white border-0 px-2 py-1 rounded"
                                    @click="removeContainer(index)">
                                    Remove
                                </button>
                            </div>
                            <div class="input-group mt-3 px-2">
                                <input type="text" class="input-field w-100 text-dark p-2" placeholder=""
                                    v-model="container.title">
                                <label class="floating-label mx-2">Program Title</label>
                            </div>
                            <div class="mt-3 px-2">
                                <label class="text-dark">Program Description:</label>
                                <textarea rows="4" class="w-100 text-dark p-1" placeholder="Description..."
                                    v-model="container.description"></textarea>
                            </div>
                            <div class="mt-3 px-2">
                                <div class="d-flex justify-content-between align-items-center mb-2">
                                    <span class="text-dark">Description Image</span>
                                    <button type="button" @click="previewImage(index)"
                                        class="vmc-bg-prime-4 text-white rounded px-3 py-1 border-0">
                                        View
                                    </button>
                                </div>
                                <div
                                    style="height:200px; width:100%; background-position:center; border:1px solid gray; margin-bottom:10px; display:flex; justify-content:center; align-items:center; overflow:hidden;">

                                    <img v-if="container.image" :src="container.image" alt="Slide Image"
                                        style="height:100%; width:100%; object-fit:contain;">

                                    <template v-else>
                                        <input type="file" :id="'upload-crewdevelopment-img-' + index"
                                            accept="image/png, image/jpeg, image/jpg" hidden
                                            @change="onImageChange($event, index)">

                                        <label :for="'upload-crewdevelopment-img-' + index"
                                            class="w-100 h-100 d-flex flex-column justify-content-center align-items-center text-center"
                                            style="cursor:pointer;">
                                            <i class="material-symbols-outlined">upload</i>
                                            <span>Upload Photo</span>
                                        </label>
                                    </template>
                                </div>
                                <button @click="resetImage(index)" type="button"
                                    class="vmc-bg-prime-6 w-100 text-white rounded px-2 py-1 border-0">
                                    Remove Photo
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
        <div class="px-3">
            <button type="submit" form="crewdevelopment" class="vmc-bg-prime-4 px-3 py-1 border-0 text-white rounded">
                Save All Changes
            </button>
        </div>
    </div>
</template>

<script>
import ToastCMS from '../ToastCMS.vue';
export default {
    name: "CrewDevelopmentCMS",
    components: {
        ToastCMS
    },
    data() {
        return {
            /* Each item: { title, description, image } — matches backend trainingList shape */
            containers: [],
            originalContainers: [],
            trainingIntro: '',
            originalTrainingIntro: '',
            trainingBackgroundVideo: '',
            trainingBackgroundImage: '',
            originalTrainingBgVideo: '',
            originalTrainingBgImage: '',
            previewImages: [],
            previewIsVideo: false,
            showPreviewModal: false,
            currentPreviewIndex: 0
        }
    },
    methods: {
        addContainer() {
            this.containers.push({ title: '', description: '', image: '' });
            this.$refs.toast.showToast(`Item # ${this.containers.length} added`, "success");
        },

        removeContainer(index) {
            this.containers.splice(index, 1);
            this.$refs.toast.showToast(`Item # ${index + 1} removed`, "error");
        },

        async onImageChange(e, index) {
    const file = e.target.files[0];
    if (file && file.type.startsWith("image/")) {
        const formData = new FormData();
        formData.append('image', file);

        try {
            const response = await fetch('/vmc/api/upload', {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('vmc_token')}`
                },
                body: formData
            });

            const data = await response.json();

            if (response.ok) {
                this.$set(this.containers[index], 'image', data.url);
                this.$refs.toast.showToast(`Image attached`, "success");
            } else {
                console.error("Upload failed:", data.message);
            }
        } catch (error) {
            console.error("Upload error:", error);
        }
    }
    e.target.value = "";
},

        resetImage(index) {
            if (!this.containers[index].image) {
                this.$refs.toast.showToast(`No attached image`, "warning");
                return;
            }
            this.$set(this.containers[index], 'image', '');
            const input = document.getElementById(`upload-crewdevelopment-img-${index}`);
            if (input) input.value = "";
            this.$refs.toast.showToast(`Image removed`, "error");
        },

        previewImage(index) {
            if (!this.containers[index].image) {
                this.$refs.toast.showToast("No images to view", "warning");
                return;
            }
            this.previewImages = [this.containers[index].image];
            this.previewIsVideo = false;
            this.currentPreviewIndex = 0;
            this.showPreviewModal = true;
        },

        async onBgMediaChange(e) {
    const file = e.target.files[0];
    if (!file) return;

    if (file.size > 10 * 1024 * 1024) {
        this.$refs.toast.showToast("File is too large! Max 10MB.", "error");
        e.target.value = "";
        return;
    }

    const formData = new FormData();
    formData.append('image', file);

    try {
        const response = await fetch('/vmc/api/upload', {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('vmc_token')}`
            },
            body: formData
        });

        const data = await response.json();

        if (response.ok) {
            if (file.type.startsWith('video/')) {
                this.trainingBackgroundVideo = data.url;
                this.trainingBackgroundImage = '';
            } else {
                this.trainingBackgroundImage = data.url;
                this.trainingBackgroundVideo = '';
            }
            this.$refs.toast.showToast("Background media attached", "success");
        } else {
            console.error("Upload failed:", data.message);
        }
    } catch (error) {
        console.error("Upload error:", error);
    }
    e.target.value = "";
},

        previewBgMedia() {
            if (!this.trainingBackgroundVideo && !this.trainingBackgroundImage) {
                this.$refs.toast.showToast("No background media to view", "warning");
                return;
            }
            if (this.trainingBackgroundVideo) {
                this.previewImages = [this.trainingBackgroundVideo];
                this.previewIsVideo = true;
            } else {
                this.previewImages = [this.trainingBackgroundImage];
                this.previewIsVideo = false;
            }
            this.currentPreviewIndex = 0;
            this.showPreviewModal = true;
        },

        removeBgMedia() {
            if (!this.trainingBackgroundVideo && !this.trainingBackgroundImage) {
                this.$refs.toast.showToast("No background media to remove", "warning");
                return;
            }
            this.trainingBackgroundVideo = '';
            this.trainingBackgroundImage = '';
            this.$refs.toast.showToast("Background media removed", "error");
        },

        closePreviewImage() {
            this.showPreviewModal = false;
            this.previewImages = [];
            this.previewIsVideo = false;
        },

        async loadFormData() {
            try {
                const token = localStorage.getItem('vmc_token');
                const response = await fetch(`${process.env.VUE_APP_API_URL}/api/content?_nocache=${new Date().getTime()}`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });

                if (!response.ok) throw new Error("Failed to fetch content");

                const data = await response.json();

                if (data && Object.keys(data).length > 0) {
                    if (Array.isArray(data.trainingList)) {
                        this.containers = data.trainingList.map(t => ({
                            title: t.title || '',
                            description: t.description || '',
                            image: t.image || ''
                        }));
                    }
                    this.trainingIntro = data.trainingIntro ?? '';
                    this.trainingBackgroundVideo = data.trainingBackgroundVideo ?? '';
                    this.trainingBackgroundImage = data.trainingBackgroundImage ?? '';
                }

                this.originalContainers = JSON.parse(JSON.stringify(this.containers));
                this.originalTrainingIntro = this.trainingIntro;
                this.originalTrainingBgVideo = this.trainingBackgroundVideo;
                this.originalTrainingBgImage = this.trainingBackgroundImage;

            } catch (error) {
                console.error("Load error:", error);
                this.$refs.toast.showToast("Failed to load data!", "error");
            }
        },

        async saveAllChanges(e) {
            e.preventDefault();

            if (!this.hasChanges) {
                this.$refs.toast.showToast("Nothing to save.", "warning");
                return;
            }

            try {
                const token = localStorage.getItem('vmc_token');
                const response = await fetch(`${process.env.VUE_APP_API_URL}/api/update`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                    body: JSON.stringify({
                        trainingList: this.containers,
                        trainingIntro: this.trainingIntro,
                        trainingBackgroundVideo: this.trainingBackgroundVideo,
                        trainingBackgroundImage: this.trainingBackgroundImage
                    })
                });

                if (!response.ok) throw new Error("Server error");

                this.originalContainers = JSON.parse(JSON.stringify(this.containers));
                this.originalTrainingIntro = this.trainingIntro;
                this.originalTrainingBgVideo = this.trainingBackgroundVideo;
                this.originalTrainingBgImage = this.trainingBackgroundImage;

                this.$refs.toast.showToast("Saved all changes.", "success");
                setTimeout(() => { window.location.reload(); }, 1500);

            } catch (error) {
                console.error("Save error:", error);
                this.$refs.toast.showToast("Save failed. Check your connection.", "error");
            }
        }
    },

    async mounted() {
        await this.loadFormData();
    },

    beforeDestroy() { },

    computed: {
        hasChanges() {
            return (
                JSON.stringify(this.containers) !== JSON.stringify(this.originalContainers) ||
                this.trainingIntro !== this.originalTrainingIntro ||
                this.trainingBackgroundVideo !== this.originalTrainingBgVideo ||
                this.trainingBackgroundImage !== this.originalTrainingBgImage
            );
        }
    }
}
</script>

<style scoped>
.toast-container {
    position: fixed;
    width: 300px;
    top: 20px;
    right: 20px;
    z-index: 9999;
}

hr {
    border-top: 1px solid black;
}

.sticky-controls {
    position: sticky;
    z-index: 1;
    background-color: white;
}

@media (min-width: 330px) {
    .main-header {
        padding: 15px 0;
        border-top: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
    }

    .crew-header {
        font-size: 17px;
        font-weight: 600;
    }

    .grid-header>div {
        width: 100%;
    }

    input,
    textarea {
        font-size: 15px;
        resize: none;
        outline: none;
    }

    input {
        height: 36px;
    }

    .input-group {
        position: relative;
        display: flex;
    }

    .input-field {
        border: 1px solid gray;
        border-radius: 4px !important;
        width: 100%;
        outline: none;
    }

    .floating-label {
        position: absolute;
        top: 50%;
        left: 8px;
        transform: translateY(-50%);
        color: gray;
        background-color: white;
        transition: all 0.3s ease;
        pointer-events: none;
    }

    .input-field:focus~.floating-label,
    .input-field:not(:placeholder-shown)~.floating-label {
        top: 0;
        left: 8px;
        transform: translateY(-50%);
        font-size: 12px;
    }

    .item-number {
        font-size: 20px;
        font-weight: 600;
    }

    .preview-modal {
        position: fixed;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, 0.8);
        z-index: 9999;
        overflow-y: hidden;
        overscroll-behavior: contain;
    }

    .modal-content img,
    .modal-content video {
        max-width: 70vw;
        max-height: 70vh;
        width: auto;
        height: auto;
        object-fit: contain;
        display: block;
        margin: 0 auto;
    }

    .close-btn {
        top: 10px;
        right: 15px;
        font-size: 24px;
        cursor: pointer;
    }

    .sticky-controls {
        top: 60px;
    }
}

@media (min-width: 768px) {
    .crew-header {
        font-size: 20px;
    }
}

@media (min-width: 992px) {
    .grid-header {
        display: flex;
        flex-wrap: wrap;
    }

    .grid-header>div {
        width: 50% !important;
        box-sizing: border-box;
    }

    .modal-content img,
    .modal-content video {
        max-height: 80vh;
    }
}

@media (min-width: 1200px) {
    .cms-container {
        margin-left: 310px;
        width: calc(100% - 310px);
        margin-top: 82px;
    }

    .sticky-controls {
        top: 82px;
    }
}
</style>